import installationInstructions from './installationInstructions';

const petFeederCategoryContent = {
  installationInstructions
}

export { petFeederCategoryContent };
